<template>
  <div v-if="render" class="page-box">
    <div class="back-box" @click="back">
      <i class="fas fa-chevron-left fa-fw"></i>
      BACK
    </div>

    <div class="lpage-head">
      <div class="lp-main-title">{{ locationLabel }} <span>Attractions</span></div>
      <div class="lp-main-sub">Discover tours and activities that bring destinations to life</div>
    </div>

    <div class="filter-box d-flex justify-space-between align-start">
      <div class="pills-box d-flex flex-wrap">
        <div :class="['pill-lr d-flex align-center', {disabled:sightSeeing.filter.categories.indexOf(x) === -1}]" v-for="x in sightSeeing.categories" @click="toggleCategory(x)">
          <span>{{ x }}</span>
        </div>
      </div>
      <div class="rd-field-box">
        <label>Sort by</label>
        <select v-model="sort">
          <option value="lowToHigh">Price: low to high</option>
          <option value="highToLow">Price: high to low</option>
        </select>
      </div>
    </div>

    <div class="attractions-grid">
      <div class="attraction-card" v-for="act in activities" @click="view(act)">
        <div class="card-image-wrap">
          <img :src="act.ImageUrl">
          <div class="card-image-overlay"></div>
          <div class="card-cancellation" v-if="act.Cancellation_available">
            <i class="fas fa-check fa-fw"></i>
            Free Cancel
          </div>
        </div>
        <div class="card-body">
          <div class="card-categories">
            <span class="cat-tag" v-for="tag in act.Cat_Ids">{{ tag }}</span>
          </div>
          <h3 class="card-title">{{ act.ProductName }}</h3>
          <p class="card-desc">{{ cleanTags(act.Description) }}</p>
          <div class="card-meta" v-if="act.Duration">
            <div class="card-meta-item">
              <i class="fas fa-clock fa-fw"></i>
              {{ act.Duration }}
            </div>
          </div>
          <div class="card-footer">
            <div class="card-price">
              <span class="currency">{{ currencySymbol[currency.code] }}</span>
              <span class="amount">{{ applyCurrency(act.Price, false) }}</span>
              <!-- <span class="amount">{{ price(act.Price) }}</span> -->
              <span class="per">/person</span>
            </div>
            <button class="card-btn">View Details</button>
          </div>
        </div>
      </div>

      <div class="empty-x" v-if="!activities.length">Empty result...</div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import currencySymbol from '@/data/currency.js'
import xcurrency from '@/modules/api/currency'

export default {
  data () {
    return {
      render: false,
      currencySymbol: currencySymbol
    }
  },
  computed: {
    sightSeeing () { return this.$store.state.sightSeeing },
    sort: {
      get () { return this.sightSeeing.sort },
      set (x) { this.$store.commit('sightSeeing/setData', {sort: x}) }
    },
    locationLabel () {
      if (!this.sightSeeing.location.selected) return ''
      return this.sightSeeing.location.selected.destinationName
    },
    activities () {
      // const filtered = this.sightSeeing.list.filter(item => {
      //   if (!item.Sub_Cat_Ids) return false
      //   return Object.values(item.Sub_Cat_Ids).includes(searchKey)
      // })

      const list = this.sightSeeing.list
      const allowedCategories = this.sightSeeing.filter.categories

      let filtered = list.filter(item => {
        if (!item.Sub_Cat_Ids) return false
        const subCategories = Object.values(item.Sub_Cat_Ids)
        return subCategories.some(cat => allowedCategories.includes(cat))
      })
      if (this.sort === 'lowToHigh') filtered = filtered.sort((a, b) => a.Price.TotalDisplayFare - b.Price.TotalDisplayFare)
      else filtered = filtered.sort((a, b) => b.Price.TotalDisplayFare - a.Price.TotalDisplayFare)
      return filtered
    },
    currency () { return this.$store.state.other.currency }
  },
  methods: {
    back () {
      this.$router.push('/search')
    },
    toggleCategory (x) {
      this.$store.commit('sightSeeing/toggleFilterCategory', x)
    },
    view (x) {
      let self = this
      this.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.post2(`${CONFIG.d2dAPI}/sightseeing/provider1/product-details`, {
        ProductCode: x.ProductCode,
        ResultToken: x.ResultToken
      }, r => {
        if (!r.Status) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.Message
          })
          return
        }
        self.$store.commit('sightSeeing/setData', {view: r.ProductDetails.SSInfoResult})
        self.$router.push('sight-seeing/view')
      })
    },
    price (data) {
      let price = data.TotalDisplayFare / this.currency.list[data.Currency]
      return price.toFixed(2)
    },
    applyCurrency (data, useSymbol = true, noComma = false) {
      let x = data.TotalDisplayFare
      if (data.Currency !== 'USD' && this.currency.code !== data.Currency) {
        x = x / this.currency.list[data.Currency]
        x = x.toString().replace(/[',']/g, '')
        x = parseFloat(x)
        x = x * this.currency.value
      }
      return xcurrency.format({
        code: this.currency.code,
        val: x.toFixed(2)
      }, useSymbol, noComma)
    },
    cleanTags (x) {
      let parser = new DOMParser()
      return parser.parseFromString(x, 'text/html').body.textContent.slice(0, 200)
    }
  },
  mounted () {
    this.render = false
    if (!this.sightSeeing.location.selected || !Object.keys(this.sightSeeing.location.selected).length) {
      this.back()
      return
    }
    this.render = true
    this.$store.commit('global/setLoaderData', {show: false})
  }
}
</script>

<style lang="scss" scoped>
.page-box{
  padding: 15px 20px;
  margin-bottom: 20px;
}
.back-box{
  color: #4a4a6a;
  letter-spacing: .7px;
  margin-bottom: 10px;
  cursor: pointer;
  
  &:hover{
    color: #ff9c09;
  }
}

.lpage-head{
  margin-bottom: 24px;
}
.lp-main-title{
  font-size: 32px;
  font-weight: 700;
  color: #1a1a2e;

  span{
    color: #ECAE20;
    font-weight: 600;
  }
}
.lp-main-sub{
  font-size: 15px;
  color: #8892a0;
}


.filter-box{
  margin-bottom: 20px;
}
.pills-box{
  gap: 10px;
  width: calc(100% - 220px);
}
.pill-lr{
  padding: 8px 16px;
  background: #fff;
  border: 1.5px solid #e2e8f0;
  border-radius: 30px;
  font-size: 13px;
  font-weight: 500;
  color: #4a4a6a;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  transition: all .2s ease;

  &.disabled{
    background: #f5f5f5;
    color: #888;
  }
}
.rd-field-box{
  background: #fff;
  border: 2px solid #CCD0E2;
  border-radius: 4px;
  line-height: 1;
  padding: 7px 10px 10px;

  label{
    display: block;
    color: #6c7c8f;
    font-size: 12px;
    margin-bottom: 2px;
  }
  select{
    padding: 0;
    width: 180px;
    border: none;
    outline: none;
    font-size: 17px;
    line-height: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}

.attractions-grid{
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 24px;
}
.attraction-card{
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(236, 174, 32, 0.08);
  transition: transform 0.25s, box-shadow 0.25s;
  display: flex;
  flex-direction: column;
  cursor: pointer;

  &:hover{
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(0,0,0,0.08), 0 0 0 1px rgba(236,174,32,0.15);

    .card-image-wrap img {
      transform: scale(1.05);
    }
  }
}
.card-image-wrap {
  position: relative;
  height: 200px;
  overflow: hidden;

  img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s;
  }
}
.card-image-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(26, 26, 46, 0.5) 0%, transparent 60%);
}
.card-cancellation {
  position: absolute;
  top: 14px;
  right: 14px;
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(34, 197, 94, 0.9);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 20px;
}
.card-body {
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.card-categories {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
}
.cat-tag {
  font-size: 11px;
  font-weight: 600;
  color: #ECAE20;
  background: rgba(236, 174, 32, 0.08);
  padding: 3px 10px;
  border-radius: 20px;
  letter-spacing: .5px;
}
.card-title {
  font-size: 17px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 10px;
  line-height: 1.3;
}
.card-desc {
  font-size: 13.5px;
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 16px;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.card-meta {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  padding-top: 12px;
  border-top: 1px solid #f1f3f6;
}
.card-meta-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: #8892a0;
  font-weight: 500;

  i{
    color: #ECAE20;
  }
}
.card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 14px;
  border-top: 1px solid #f1f3f6;
}
.card-price {
  display: flex;
  align-items: baseline;
  gap: 4px;

  .currency {
    font-size: 13px;
    font-weight: 600;
    color: #8892a0;
  }
  .amount {
    font-size: 24px;
    font-weight: 700;
    color: #1a1a2e;
  }
  .per {
    font-size: 12px;
    color: #b0b8c4;
  }
}
.card-btn {
  padding: 10px 22px;
  background: #ECAE20;
  color: #1a1a2e;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
}

.empty-x{
  padding: 30px 0;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 1px;
  font-style: italic;
  color: #aaa;
}

@media (max-width: 800px) {
  .attractions-grid { grid-template-columns: 1fr; }
}

@media only screen and (max-width: 641px) {
  .page-box{
    padding: 0 20px;
  }
  .bread-box{
    font-size: 14px;
    margin-bottom: 10px;
    letter-spacing: .6px;
  }
  .filter-box{
    flex-direction: column;
    align-items: start;
    gap: 20px;
    margin-bottom: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// index.vue?66ce5b94